import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { ComunaService } from 'src/app/services/comuna.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ProvinciaService } from 'src/app/services/provincia.service';
import { RegionService } from 'src/app/services/region.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-add-edit-proveedor',
  templateUrl: './add-edit-proveedor.component.html',
  styleUrls: ['../proveedor.component.scss'],
  providers: [SecurityService],
})
export class AddEditProveedorComponent implements OnInit {
  @Output() onSuccess: EventEmitter<'ADD' | 'EDIT'> = new EventEmitter<'ADD' | 'EDIT'>();

  mode: 'ADD' | 'EDIT' | 'VIEW';

  // Modales
  @ViewChild('centralLarge', { static: true }) modalAddEdit: ModalDirective;

  formHeader: FormGroup;

  // Data & Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private rutUsuario: number;
  proveedor: any;

  optionsRegion: Array<any> = [];
  optionsProvincia: Array<any> = [];
  optionsComuna: Array<any> = [];
  optionsCondicionPago: Array<any> = [];

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private regionService: RegionService,
    private provinciaService: ProvinciaService,
    private comunaService: ComunaService,
    private condicionPagoService: CondicionPagoService,
    private clienteProveedorService: ClienteProveedorService
  ) {
    this.log = this.clog.log('PROVEEDOR ADD/EDIT');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.loadRegiones();
    this.loadCondicionPago();

    this.createForms();
    this.formChangesSubscriptions();
  }

  show() {
    this.formHeader.enable();
    this.cleanup();
    this.mode = 'ADD';
    this.modalAddEdit.show();
    this.formHeader.get('basicos.activo').setValue(true);
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('contacto.region_codigo'), this.optionsRegion);
  }

  showToView(proveedor) {
    this.formHeader.disable();
    this.cleanup();
    this.mode = 'VIEW';
    this.proveedor = proveedor;
    this.modalAddEdit.show();
    this.loadProveedor();
  }

  showToEdit(proveedor) {
    this.formHeader.enable();
    this.cleanup();
    this.mode = 'EDIT';
    this.proveedor = proveedor;
    this.modalAddEdit.show();
    this.loadProveedor();
  }

  cleanup() {
    this.formValidatorsService.reset(this.formHeader);

    this.formHeader.get('basicos.activo').setValue(false);
    this.formHeader.get('basicos.rut').setValue('');
    this.formHeader.get('basicos.nombre').setValue('');
    this.formHeader.get('basicos.giro').setValue('');

    this.formHeader.get('contacto.direccion_completa').setValue('');
    this.formHeader.get('contacto.region_codigo').setValue(null);
    this.formHeader.get('contacto.provincia_codigo').setValue(null);
    this.formHeader.get('contacto.comuna_codigo').setValue(null);
    this.formHeader.get('contacto.telefono_principal').setValue('');
    this.formHeader.get('contacto.mail_contacto').setValue('');
    this.formHeader.get('contacto.nombre_contacto').setValue('');

    this.formHeader.get('comerciales.observaciones').setValue('');
    this.formHeader.get('comerciales.condicion_pago_codigo').setValue(null);
    this.formHeader.get('comerciales.dias_plazo').setValue(null);
    this.formHeader.get('comerciales.no_aplica_fec_venc').setValue(false);
    this.formHeader.get('comerciales.es_canje').setValue(false);
    this.formHeader.get('comerciales.tiene_maquina').setValue(false);

    // this.formValidatorsService.reset(this.formHeader)

    const esCanje: boolean = false;
    this.formHeader.get('basicos.activo').setValue(false);
    this.formHeader.get('comerciales.no_aplica_fec_venc').setValue(false);
    this.formHeader.get('comerciales.es_canje').setValue(esCanje);

    // this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('contacto.region_codigo'), this.optionsRegion);

    //this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('comerciales.condicion_pago_codigo'), this.optionsCondicionPago);
    this.formHeader.get('comerciales.dias_plazo').disable();

    // this.setValidatorsByProveedorCanje(esCanje)
  }

  cerrarModal() {
    this.cleanup();
    this.modalAddEdit.hide();
  }

  setValidatorsByProveedorCanje(proveedorDeCanje: boolean) {
    this.log('setValidatorsByProveedorCanje', proveedorDeCanje);
    this.formHeader.get('contacto.mail_contacto').setValidators(null);
    this.formHeader.get('contacto.nombre_contacto').setValidators([]);
    this.formHeader.get('comerciales.observaciones').setValidators([]);

    if (!proveedorDeCanje) {
      this.log('setValidators required');
    }
  }

  loadRegiones() {
    const inputParams = {
      entidad: {
        codigo: -1,
      },
    };
    this.regionService.obtenerRegionSegunCodigo(inputParams, ({ respuesta, mensajes }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;

      this.optionsRegion = registros.map((region) => ({
        value: region.codigo,
        label: region.nombre,
        ...region,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('contacto.region_codigo'), this.optionsRegion);
    });
  }

  loadCondicionPago() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      tipobusqueda: 1,
    };

    this.condicionPagoService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.optionsCondicionPago = registros.map((condicionPago) => ({
        value: condicionPago.codigo,
        label: condicionPago.descripcion,
        ...condicionPago,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('comerciales.condicion_pago_codigo'), this.optionsCondicionPago);
    });
  }

  private createForms() {
    this.formHeader = this.fb.group({
      basicos: this.fb.group({
        activo: [false, [Validators.required]],
        rut: [null, [Validators.required]],
        nombre: ['', [Validators.required, Validators.maxLength(100)]],
        giro: ['', [Validators.required, Validators.maxLength(100)]],
      }),
      contacto: this.fb.group({
        direccion_completa: ['', [Validators.required]],
        region_codigo: [null, [Validators.required]],
        provincia_codigo: [null],
        comuna_codigo: [null, [Validators.required]],
        telefono_principal: [null],
        mail_contacto: [''],
        nombre_contacto: [''],
      }),
      comerciales: this.fb.group({
        observaciones: [''],
        condicion_pago_codigo: [null, [Validators.required]],
        dias_plazo: [null],
        no_aplica_fec_venc: [false],
        es_canje: [false],
        tiene_maquina: [false, [Validators.required]],
      }),
    });

    this.formHeader.get('comerciales.dias_plazo').disable();
  }

  formChangesSubscriptions() {
    this.formHeader.get('contacto.region_codigo').valueChanges.subscribe((region_codigo) => {
      if (!region_codigo) return;
      this.loadProvinciasByRegion(region_codigo);
    });
    this.formHeader.get('contacto.provincia_codigo').valueChanges.subscribe((provincia_codigo) => {
      if (!provincia_codigo) return;
      this.loadComunasByProvincia(provincia_codigo);
    });
    this.formHeader.get('comerciales.condicion_pago_codigo').valueChanges.subscribe((condicion_pago_codigo) => {
      if (!condicion_pago_codigo) return;
      this.handleCondicionPagoChange(condicion_pago_codigo);
    });
    this.formHeader.get('comerciales.es_canje').valueChanges.subscribe((es_canje) => {
      if (es_canje !== null && es_canje !== undefined) {
        this.log('es_canje change', es_canje);
        this.setValidatorsByProveedorCanje(es_canje);
      }
    });
    this.formHeader.get('basicos.rut').valueChanges.subscribe((rut) => {
      if (rut && this.mode === 'ADD') {
        this.buscarProveedorEsCliente(rut);
      }
    });
  }

  loadProvinciasByRegion(region_codigo) {
    const inputParams = {
      entidad: {
        codigo: -1,
        nombre: '',
        region_codigo,
      },
    };

    this.provinciaService.obtenerSegunFiltro(inputParams, ({ respuesta, mensajes }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;

      this.optionsProvincia = registros.map((provincia) => ({
        value: provincia.codigo,
        label: provincia.nombre,
        ...provincia,
      }));
      //this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('contacto.provincia_codigo'), this.optionsProvincia);
    });
  }

  loadComunasByProvincia(provincia_codigo) {
    const inputParams = {
      entidad: {
        codigo: -1,
        nombre: '',
        provincia_codigo,
      },
    };

    this.comunaService.obtenerComunaSegunCodigo(inputParams, ({ respuesta, mensajes }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;

      this.optionsComuna = registros.map((comuna) => ({
        value: comuna.codigo,
        label: comuna.nombre,
        ...comuna,
      }));

      //this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('contacto.comuna_codigo'), this.optionsComuna);
    });
  }

  handleCondicionPagoChange(condicion_pago_codigo) {
    // this.log('handleCondicionPagoChange', condicion_pago_codigo)
    const optionsCondicionPagoFiltered = this.optionsCondicionPago.filter((p) => p.codigo === condicion_pago_codigo);
    if (optionsCondicionPagoFiltered.length > 0) {
      const condicionPago = optionsCondicionPagoFiltered[0];
      this.formHeader.get('comerciales.dias_plazo').setValue(condicionPago.cantidad_dias);
    }
  }

  buscarProveedorEsCliente(rut: string) {
    if (!rut || rut.trim() === '') return;

    // Limpiar el RUT y quitar el dígito verificador
    const rutSinDV = this.rutService.QuitarDV(this.rutService.Limpiar(rut));

    if (!rutSinDV || rutSinDV === 0) return;

    const inputParams = {
      entidad: {
        rut: rutSinDV
      }
    };

    this.log('Buscando proveedor es cliente con RUT:', rutSinDV);

    this.clienteProveedorService.ObteneProveedorEsCliente(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        // Si hay mensajes de error, mostrarlos
        mensajes.forEach(mensaje => {
          this.toastService.error(mensaje.texto);
        });
        return;
      }

      if (respuesta) {
        // Si hay respuesta, autocompletar los campos
        this.autocompletarCamposProveedor(respuesta);
        this.log('Proveedor encontrado como cliente, campos autocompletados');
      } else {
        // Si no hay respuesta, el proveedor no existe como cliente
        this.log('Proveedor no existe como cliente, debe agregarse manualmente');
      }
    });
  }

  autocompletarCamposProveedor(datosCliente: any) {
    try {
      // Autocompletar datos básicos
      if (datosCliente.razon_social) {
        this.formHeader.get('basicos.nombre').setValue(datosCliente.razon_social);
      }

      if (datosCliente.giro) {
        this.formHeader.get('basicos.giro').setValue(datosCliente.giro);
      }

      // Autocompletar datos de contacto
      // Lógica mejorada para teléfono: usar telefono_secundario como fallback
      let telefonoFinal = '';
      if (datosCliente.telefono_principal &&
        datosCliente.telefono_principal !== '' &&
        datosCliente.telefono_principal !== '0' &&
        datosCliente.telefono_principal !== 0) {
        telefonoFinal = datosCliente.telefono_principal;
      } else if (datosCliente.telefono_secundario &&
        datosCliente.telefono_secundario !== '' &&
        datosCliente.telefono_secundario !== '0' &&
        datosCliente.telefono_secundario !== 0) {
        telefonoFinal = datosCliente.telefono_secundario;
      }

      this.formHeader.get('contacto.telefono_principal').setValue(telefonoFinal);

      if (datosCliente.mail_contacto) {
        this.formHeader.get('contacto.mail_contacto').setValue(datosCliente.mail_contacto);
      }

      // Autocompletar dirección completa si está disponible
      if (datosCliente.direccion_completa) {
        this.formHeader.get('contacto.direccion_completa').setValue(datosCliente.direccion_completa);
      }

      // Autocompletar datos comerciales
      if (datosCliente.observaciones) {
        this.formHeader.get('comerciales.observaciones').setValue(datosCliente.observaciones);
      }

      if (datosCliente.condicion_pago_codigo) {
        this.formHeader.get('comerciales.condicion_pago_codigo').setValue(datosCliente.condicion_pago_codigo);
      }

      if (datosCliente.no_aplica_fec_venc !== null && datosCliente.no_aplica_fec_venc !== undefined) {
        this.formHeader.get('comerciales.no_aplica_fec_venc').setValue(datosCliente.no_aplica_fec_venc);
      }

      if (datosCliente.activo !== null && datosCliente.activo !== undefined) {
        this.formHeader.get('basicos.activo').setValue(datosCliente.activo);
      }

      if (datosCliente.tiene_maquina !== null && datosCliente.tiene_maquina !== undefined) {
        this.formHeader.get('comerciales.tiene_maquina').setValue(datosCliente.tiene_maquina);
      }

      if (datosCliente.es_canje !== null && datosCliente.es_canje !== undefined) {
        this.formHeader.get('comerciales.es_canje').setValue(datosCliente.es_canje);
      }

      // Manejar región, provincia y comuna si están disponibles
      if (datosCliente.region_codigo) {
        this.formHeader.get('contacto.region_codigo').setValue(datosCliente.region_codigo);
        // Cargar provincias para esta región
        this.loadProvinciasByRegion(datosCliente.region_codigo);
      }

      if (datosCliente.provincia_codigo) {
        // Esperar un poco para que se carguen las provincias antes de seleccionar
        setTimeout(() => {
          this.formHeader.get('contacto.provincia_codigo').setValue(datosCliente.provincia_codigo);
          this.loadComunasByProvincia(datosCliente.provincia_codigo);
        }, 500);
      }

      if (datosCliente.codigo_comuna) {
        // Esperar un poco para que se carguen las comunas antes de seleccionar
        setTimeout(() => {
          this.formHeader.get('contacto.comuna_codigo').setValue(datosCliente.codigo_comuna);
        }, 1000);
      }

      this.log('Campos autocompletados exitosamente');
    } catch (error) {
      this.log('Error al autocompletar campos:', error);
      this.toastService.error('Error al autocompletar los campos del formulario');
    }
  }

  loadProveedor() {
    const rut = this.rutService.AgregarDV(this.proveedor.cliente_proveedor.rut);
    this.formHeader.get('basicos.activo').setValue(this.proveedor.cliente_proveedor.activo);
    this.formHeader.get('basicos.rut').setValue(rut);
    this.formHeader.get('basicos.nombre').setValue(this.proveedor.cliente_proveedor.nombre);
    this.formHeader.get('basicos.giro').setValue(this.proveedor.cliente_proveedor.giro);

    this.formHeader.get('contacto.direccion_completa').setValue(this.proveedor.direccion.direccion_completa);
    this.formHeader.get('contacto.region_codigo').setValue(this.proveedor.direccion.region_codigo);
    this.formHeader.get('contacto.provincia_codigo').setValue(this.proveedor.direccion.provincia_codigo);
    this.formHeader.get('contacto.comuna_codigo').setValue(this.proveedor.direccion.comuna_codigo);
    this.formHeader.get('contacto.telefono_principal').setValue(this.proveedor.cliente_proveedor.telefono_principal);
    this.formHeader.get('contacto.mail_contacto').setValue(this.proveedor.cliente_proveedor.mail_contacto);
    this.formHeader.get('contacto.nombre_contacto').setValue(this.proveedor.direccion.nombre_contacto);

    this.formHeader.get('comerciales.observaciones').setValue(this.proveedor.cliente_proveedor.observaciones);
    this.formHeader.get('comerciales.condicion_pago_codigo').setValue(this.proveedor.direccion.condicion_pago_codigo);
    // this.formHeader.get('comerciales.dias_plazo').setValue(this.proveedor.cliente_proveedor.dias_plazo)
    this.formHeader.get('comerciales.no_aplica_fec_venc').setValue(this.proveedor.cliente_proveedor.no_aplica_fec_venc);
    this.formHeader.get('comerciales.es_canje').setValue(this.proveedor.cliente_proveedor.es_canje);
    this.formHeader.get('comerciales.tiene_maquina').setValue(this.proveedor.cliente_proveedor.tiene_maquina);
  }

  validateForm() {
    this.formHeader.get('comerciales.dias_plazo').enable();
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    this.formHeader.get('comerciales.dias_plazo').disable();
  }

  create() {
    this.validateForm();

    this.log(
      'basicos.activo:',
      this.formHeader.get('basicos.activo').value,
      this.formHeader.get('basicos.activo').valid,
      'basicos.rut:',
      this.formHeader.get('basicos.rut').value,
      this.formHeader.get('basicos.rut').valid,
      'basicos.nombre:',
      this.formHeader.get('basicos.nombre').value,
      this.formHeader.get('basicos.nombre').valid,
      'basicos.giro:',
      this.formHeader.get('basicos.giro').value,
      this.formHeader.get('basicos.giro').valid
    );
    this.log(
      'contacto.direccion_completa:',
      this.formHeader.get('contacto.direccion_completa').value,
      this.formHeader.get('contacto.direccion_completa').valid,
      'contacto.comuna_codigo:',
      this.formHeader.get('contacto.comuna_codigo').value,
      this.formHeader.get('contacto.comuna_codigo').valid,
      'contacto.telefono_principal:',
      this.formHeader.get('contacto.telefono_principal').value,
      this.formHeader.get('contacto.telefono_principal').valid,
      'contacto.mail_contacto:',
      this.formHeader.get('contacto.mail_contacto').value,
      this.formHeader.get('contacto.mail_contacto').valid,
      'contacto.nombre_contacto:',
      this.formHeader.get('contacto.nombre_contacto').value,
      this.formHeader.get('contacto.nombre_contacto').valid
    );
    this.log(
      'comerciales.observaciones:',
      this.formHeader.get('comerciales.observaciones').value,
      this.formHeader.get('comerciales.observaciones').valid,
      'comerciales.condicion_pago_codigo:',
      this.formHeader.get('comerciales.condicion_pago_codigo').value,
      this.formHeader.get('comerciales.condicion_pago_codigo').valid,
      'comerciales.dias_plazo:',
      this.formHeader.get('comerciales.dias_plazo').value,
      this.formHeader.get('comerciales.dias_plazo').valid,
      'comerciales.no_aplica_fec_venc:',
      this.formHeader.get('comerciales.no_aplica_fec_venc').value,
      this.formHeader.get('comerciales.no_aplica_fec_venc').valid,
      'comerciales.es_canje:',
      this.formHeader.get('comerciales.es_canje').value,
      this.formHeader.get('comerciales.es_canje').valid
    );

    // this.log('basicos.activo:', this.formHeader.get('basicos.activo').value, 'basicos.rut:', this.formHeader.get('basicos.rut').value, 'basicos.nombre:', this.formHeader.get('basicos.nombre').value, 'basicos.giro:', this.formHeader.get('basicos.giro').value)
    // this.log('contacto.direccion_completa:', this.formHeader.get('contacto.direccion_completa').value, 'contacto.comuna_codigo:', this.formHeader.get('contacto.comuna_codigo').value, 'contacto.telefono_principal:', this.formHeader.get('contacto.telefono_principal').value, 'contacto.mail_contacto:', this.formHeader.get('contacto.mail_contacto').value, 'contacto.nombre_contacto:', this.formHeader.get('contacto.nombre_contacto').value)
    // this.log('comerciales.observaciones:', this.formHeader.get('comerciales.observaciones').value, 'comerciales.condicion_pago_codigo:', this.formHeader.get('comerciales.condicion_pago_codigo').value, 'comerciales.dias_plazo:', this.formHeader.get('comerciales.dias_plazo').value, 'comerciales.no_aplica_fec_venc:', this.formHeader.get('comerciales.no_aplica_fec_venc').value, 'comerciales.es_canje:', this.formHeader.get('comerciales.es_canje').value)

    if (!this.formHeader.valid) return;

    const { basicos, contacto, comerciales } = this.formHeader.value;

    const { activo, rut: rutProveedor, nombre, giro } = basicos;
    const { direccion_completa, comuna_codigo, telefono_principal, mail_contacto, nombre_contacto } = contacto;
    const { observaciones, condicion_pago_codigo, dias_plazo, no_aplica_fec_venc, es_canje, tiene_maquina } = comerciales;

    const rut = this.rutService.QuitarDV(this.rutService.Limpiar(rutProveedor));

    const inputParams = {
      entidad: {
        cliente_proveedor: {
          empresa_rut: this.rutEmpresa,
          rut_usuario_creacion: this.rutUsuario,
          rut,
          nombre,
          giro,
          telefono_principal,
          mail_contacto,
          activo,
          observaciones: observaciones.trim(),
          no_aplica_fec_venc,
          es_canje,
          tiene_maquina,
        },
        direccion: {
          direccion_completa,
          comuna_codigo,
          nombre_contacto,
          condicion_pago_codigo,
        },
      },
    };
    this.log('inputParams', JSON.stringify(inputParams));

    this.clienteProveedorService.agregarProveedor(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.onSuccess.emit('ADD');
      this.cleanup();
      this.modalAddEdit.hide();
      this.toastService.success('Operación exitosa');
    });
  }

  update() {
    this.validateForm();

    if (!this.formHeader.valid) return;

    const { basicos, contacto, comerciales } = this.formHeader.value;

    const { activo, rut: rutProveedor, nombre, giro } = basicos;
    const { direccion_completa, comuna_codigo, telefono_principal, mail_contacto, nombre_contacto } = contacto;
    const { observaciones, condicion_pago_codigo, dias_plazo, no_aplica_fec_venc, es_canje, tiene_maquina } = comerciales;

    const rut = this.rutService.QuitarDV(this.rutService.Limpiar(rutProveedor));

    const inputParams = {
      entidad: {
        cliente_proveedor: {
          empresa_rut: this.rutEmpresa,
          rut_usuario_actualiza: this.rutUsuario,
          rut,
          nombre,
          giro,
          telefono_principal,
          mail_contacto,
          activo,
          observaciones: observaciones.trim(),
          no_aplica_fec_venc,
          es_canje,
          tiene_maquina,
        },
        direccion: {
          codigo: this.proveedor.direccion.codigo,
          direccion_completa,
          comuna_codigo,
          nombre_contacto,
          condicion_pago_codigo,
        },
      },
    };
    this.log('inputParams', JSON.stringify(inputParams));

    this.clienteProveedorService.editarProveedor(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.onSuccess.emit('EDIT');
      this.cleanup();
      this.modalAddEdit.hide();
      this.toastService.success('Operación exitosa');
    });
  }
}
